import { timeParse } from 'd3'
const costStructureChartData = [
  {
      "dateString": "2010-12-31",
      "Dividends Paid Out": "0",
      "nonOperatingCost": "27004.1255",
      "otherOperatingCost": "26077.72015",
      "SAndGA": "12061.88753",
      "CoGs": "6208.954081",
      "chart_name": "Cost Structure over Time",
      "chart_number": "7"
  },
  {
      "dateString": "2011-06-30",
      "Dividends Paid Out": "0",
      "nonOperatingCost": "27733.6788",
      "otherOperatingCost": "27112.85657",
      "SAndGA": "11548.05318",
      "CoGs": "6247.972298",
      "chart_name": "Cost Structure over Time",
      "chart_number": "7"
  },
  {
      "dateString": "2011-12-31",
      "Dividends Paid Out": "0",
      "nonOperatingCost": "29174.45748",
      "otherOperatingCost": "28612.77802",
      "SAndGA": "11564.93496",
      "CoGs": "6575.382823",
      "chart_name": "Cost Structure over Time",
      "chart_number": "7"
  },
  {
      "dateString": "2012-06-30",
      "Dividends Paid Out": "0",
      "nonOperatingCost": "34252.87547",
      "otherOperatingCost": "32682.54089",
      "SAndGA": "13188.53563",
      "CoGs": "7562.863204",
      "chart_name": "Cost Structure over Time",
      "chart_number": "7"
  },
  {
      "dateString": "2012-12-31",
      "Dividends Paid Out": "50252.90957",
      "nonOperatingCost": "40937.47505",
      "otherOperatingCost": "39513.24191",
      "SAndGA": "16729.42546",
      "CoGs": "9192.433214",
      "chart_name": "Cost Structure over Time",
      "chart_number": "7"
  },
  {
      "dateString": "2013-06-30",
      "Dividends Paid Out": "56678.53465",
      "nonOperatingCost": "45968.39857",
      "otherOperatingCost": "45426.30011",
      "SAndGA": "19368.06218",
      "CoGs": "10651.32089",
      "chart_name": "Cost Structure over Time",
      "chart_number": "7"
  },
  {
      "dateString": "2013-12-31",
      "Dividends Paid Out": "62627.46278",
      "nonOperatingCost": "51914.30176",
      "otherOperatingCost": "51132.84495",
      "SAndGA": "20712.51181",
      "CoGs": "11640.64766",
      "chart_name": "Cost Structure over Time",
      "chart_number": "7"
  },
  {
      "dateString": "2014-06-30",
      "Dividends Paid Out": "76532.24183",
      "nonOperatingCost": "56365.56439",
      "otherOperatingCost": "55567.97878",
      "SAndGA": "22371.73289",
      "CoGs": "13909.62543",
      "chart_name": "Cost Structure over Time",
      "chart_number": "7"
  },
  {
      "dateString": "2014-12-31",
      "Dividends Paid Out": "74117.53313",
      "nonOperatingCost": "53951.63866",
      "otherOperatingCost": "53374.2566",
      "SAndGA": "22741.35569",
      "CoGs": "15640.578",
      "chart_name": "Cost Structure over Time",
      "chart_number": "7"
  },
  {
      "dateString": "2015-06-30",
      "Dividends Paid Out": "44050.45062",
      "nonOperatingCost": "36069.43244",
      "otherOperatingCost": "35678.99053",
      "SAndGA": "21872.3718",
      "CoGs": "15160.6843",
      "chart_name": "Cost Structure over Time",
      "chart_number": "7"
  },
  {
      "dateString": "2015-12-31",
      "Dividends Paid Out": "46891.71452",
      "nonOperatingCost": "30839.30484",
      "otherOperatingCost": "30229.91992",
      "SAndGA": "20468.68679",
      "CoGs": "14377.5291",
      "chart_name": "Cost Structure over Time",
      "chart_number": "7"
  },
  {
      "dateString": "2016-06-30",
      "Dividends Paid Out": "63891.39841",
      "nonOperatingCost": "39745.443",
      "otherOperatingCost": "38948.87734",
      "SAndGA": "19924.39396",
      "CoGs": "14138.14834",
      "chart_name": "Cost Structure over Time",
      "chart_number": "7"
  },
  {
      "dateString": "2016-12-31",
      "Dividends Paid Out": "47846.06474",
      "nonOperatingCost": "31788.937",
      "otherOperatingCost": "30710.16677",
      "SAndGA": "21446.91653",
      "CoGs": "15035.50432",
      "chart_name": "Cost Structure over Time",
      "chart_number": "7"
  },
  {
      "dateString": "2017-06-30",
      "Dividends Paid Out": "40668.88594",
      "nonOperatingCost": "24624.1846",
      "otherOperatingCost": "23199.28839",
      "SAndGA": "23199.2884",
      "CoGs": "16420.8907",
      "chart_name": "Cost Structure over Time",
      "chart_number": "7"
  },
  {
      "dateString": "2017-12-31",
      "Dividends Paid Out": "40980.67946",
      "nonOperatingCost": "24834.48522",
      "otherOperatingCost": "23330.3923",
      "SAndGA": "23330.39229",
      "CoGs": "16378.36854",
      "chart_name": "Cost Structure over Time",
      "chart_number": "7"
  },
  {
      "dateString": "2018-06-30",
      "Dividends Paid Out": "40926.30512",
      "nonOperatingCost": "24765.58154",
      "otherOperatingCost": "22589.25277",
      "SAndGA": "22589.25277",
      "CoGs": "16825.14675",
      "chart_name": "Cost Structure over Time",
      "chart_number": "7"
  },
  {
      "dateString": "2018-12-31",
      "Dividends Paid Out": "42415.85274",
      "nonOperatingCost": "26334.09197",
      "otherOperatingCost": "23152.06806",
      "SAndGA": "23152.06806",
      "CoGs": "16968.35273",
      "chart_name": "Cost Structure over Time",
      "chart_number": "7"
  },
  {
      "dateString": "2019-06-30",
      "Dividends Paid Out": "42787.49462",
      "nonOperatingCost": "26703.06277",
      "otherOperatingCost": "24053.45286",
      "SAndGA": "24053.45287",
      "CoGs": "17601.70388",
      "chart_name": "Cost Structure over Time",
      "chart_number": "7"
  },
  {
      "dateString": "2019-12-31",
      "Dividends Paid Out": "42333.41354",
      "nonOperatingCost": "26279.14529",
      "otherOperatingCost": "24023.0874",
      "SAndGA": "24023.0874",
      "CoGs": "19134.01978",
      "chart_name": "Cost Structure over Time",
      "chart_number": "7"
  },
  {
      "dateString": "2020-06-30",
      "Dividends Paid Out": "30877.49079",
      "nonOperatingCost": "22915.5955",
      "otherOperatingCost": "20800.58774",
      "SAndGA": "20800.58774",
      "CoGs": "16479.50244",
      "chart_name": "Cost Structure over Time",
      "chart_number": "7"
  }
]

const parsedateString = timeParse('%Y-%m-%d')
export default costStructureChartData.map(d => {
  d['date'] = parsedateString(d['dateString'])
  return d
})
